import { createSelector } from '@reduxjs/toolkit';
import {
  BaseQueryFn,
  SubscriptionOptions,
  TypedUseInfiniteQuery,
  TypedUseQueryStateResult,
} from '@reduxjs/toolkit/dist/query/react';

type SelectorType<T> = TypedUseQueryStateResult<{ pages: T[] }, unknown, BaseQueryFn>;

const selectCombinedData = createSelector(
  <T>(res: SelectorType<T>, selector: string) => {
    return { data: res.data, selector };
  },
  (data) => {
    return data?.data?.pages
      ?.filter((obj) => obj !== null)
      ?.map((item) =>
        !data.selector
          ? item
          : item && (item as any)[data.selector as keyof typeof item]
            ? (item as any)[data.selector as keyof typeof item]
            : [],
      )
      ?.flat();
  },
);

const useInfiniteQuery = <T>({
  queryFn,
  args,
  options,
  selector = 'rows',
}: {
  queryFn: TypedUseInfiniteQuery<T, any, any, any>;
  args: any;
  options?: SubscriptionOptions & {
    skip?: boolean | undefined;
    refetchOnMountOrArgChange?: number | boolean | undefined;
    initialPageParam?: any;
  };
  selector?: string;
}) => {
  const response = queryFn(args, {
    selectFromResult: (result) => {
      return {
        ...result,
        data: selectCombinedData(result, selector),
      };
    },
    ...options,
  });
  return response;
};

export default useInfiniteQuery;
